<template>
  <div class="media">
    <v-container>
      <p>
        
        <!-- uploadDone: Callback function that contains the uploaded file URL -->
        <!-- cropper: Boolean, required as true to activate the cropper -->
        <!-- resize: True to automaticly resize the image, false to manually resize -->
        <!-- Height: Height of the cropped image -->
        <!-- width: Width of the cropped image -->
        <!-- Path: Folder Path for the storage bucket, defaults to media -->
        <MediaUploader
          v-on:uploadDone="uploadDone"
          :cropper="true"
          :resize="true"
          type="image"
          :height="300"
          :width="300"
          :path="'test'"
        />
      </p>
      <p>
        <v-img :src="src" contain :heigth="300" :width="300" />
      </p>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "media-tester",
  route: {
    path: "/media-tester/",
    name: "media-tester",
  },
  data: () => ({
    drawer: false,
    currentIndex: 0,
    src: "https://firebasestorage.googleapis.com/v0/b/npc-connect.appspot.com/o/medias%2Fpexels-eva-elijas-5768401.jpg?alt=media&token=1689d767-55f6-4a79-844c-710b93edc131",
    pdfLink: "",
  }),
  components: {
    MediaUploader: () =>
      import("../../components/MediaUploader/MediaUploader.vue"),
  },
  methods: {
    uploadDone(payload) {
      this.src = payload.url;
    },
  },
};
</script>
